import { CSSProperties, RefCallback, RefObject, VFC } from "react";
import {
  Grid,
  FormControl,
  TextField,
  InputLabel,
  MenuItem,
  Autocomplete,
} from "@mui/material";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import React from "react";
export interface PullDownItem {
  key: string;
  value: string;
}
type Props = {
  label?: string;
  name?: string;
  xs?: number;
  items: PullDownItem[];
  isSuggest?: boolean;
  isDisplayEmpty?: boolean;
  fullWidth?: boolean;
  inline?: boolean;
  style?: CSSProperties;
  mandatory?: boolean;
  disabled?: boolean
  // useStateと制御コントロールで使用
  handle?: (e: SelectChangeEvent) => void;
  value?: string;
  // useForm(React Hook Form)で使用
  onChange?: (e: SelectChangeEvent) => void;
  onBlur?: (e: any) => void;
  defaultValue?: string;
  emptyItemLabel?: string;
};

export const FormPullDown: VFC<Props> = React.forwardRef(({
  label,
  name,
  items,
  isSuggest = false,
  isDisplayEmpty = false,
  xs = 10,
  fullWidth = true,
  inline = false,
  style,
  mandatory = false,
  disabled,
  handle,
  value,
  onChange,
  onBlur,
  defaultValue,
  emptyItemLabel = "選択してください",
}, ref) => {
  const defaultProps = {
    options: items,
    getOptionLabel: (option: PullDownItem) => option.value,
  };

  let formControl;
  if (isSuggest) {
    formControl = (
      <FormControl fullWidth={fullWidth}>
        <Autocomplete
          {...defaultProps}
          renderInput={(params) => (
            <TextField
              {...params}
              label={label}
              size="small"
              InputLabelProps={{
                shrink: true,
              }}
            />
          )}
        />
      </FormControl>
    );
  } else {
    formControl = (
      <FormControl fullWidth={fullWidth}>
        {undefined !== label && <InputLabel shrink>{label}</InputLabel>}
        <Select
          name={name}
          label={label}
          size="small"
          notched
          style={style}
          disabled={disabled}
          displayEmpty={isDisplayEmpty}
          value={value}
          onChange={handle ?? onChange}
          onBlur={onBlur}
          ref={ref}
          defaultValue={defaultValue ?? (mandatory ? items[0]?.key ?? "" : "")}
        >
          {!mandatory && <MenuItem value="">{emptyItemLabel}</MenuItem>}
          {items.map((item) => (
            <MenuItem key={item.key} value={item.key}>
              {item.value}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    );
  }
  return inline ? formControl : <Grid item xs={xs}>{formControl}</Grid>
});
